// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDOCuKp9I2BWedRHG5jZNi0EEbyXcaF7dk",
  authDomain: "spn-querries.firebaseapp.com",
  projectId: "spn-querries",
  storageBucket: "spn-querries.firebasestorage.app",
  messagingSenderId: "611077676520",
  appId: "1:611077676520:web:a7d37aa90385ee6d1a985d",
  measurementId: "G-2BKETWH9RB"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default app